import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/lib/refusals";   // before anything can raise one: red refusals stay until tapped, warnings until the next action
import App from "@/App";

// Benign "ResizeObserver loop completed with undelivered notifications" — swallow it so
// CRA's dev error overlay doesn't cover the page (it's harmless and never reaches prod).
const _roLoop = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener("error", (e) => {
  if (e.message && _roLoop.test(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
